import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { InspectionCompletionStepNameSchema } from '../entities/inspectionCompletionProcessing.js';
import { InspectionsServiceEventBaseSchema, inspectionsServiceEventType } from './service.js';
const completionProcessingEventType = (eventName) => inspectionsServiceEventType('completionProcessing', eventName);
export const CompletionProcessingFailedStepSchema = z.object({
    step: InspectionCompletionStepNameSchema,
    error: z.string().optional(),
});
export const CompletionProcessingDoneEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: completionProcessingEventType('done'),
    schemaVersion: z.literal(1),
    completionProcessing: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
        photoCount: z.number().int().nonnegative(),
        documentCount: z.number().int().nonnegative(),
        videoCount: z.number().int().nonnegative(),
        videoConcatJobId: z.string().optional(),
        failedSteps: CompletionProcessingFailedStepSchema.array(),
    }),
}));
